/* tslint:disable */
/* eslint-disable */
/**
 * VoresAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreateArticleCtaLeadForm
 */
export interface CreateArticleCtaLeadForm {
    /**
     *
     * @type {string}
     * @memberof CreateArticleCtaLeadForm
     */
    ctaId: string;
    /**
     *
     * @type {string}
     * @memberof CreateArticleCtaLeadForm
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof CreateArticleCtaLeadForm
     */
    phone: string;
    /**
     *
     * @type {string}
     * @memberof CreateArticleCtaLeadForm
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof CreateArticleCtaLeadForm
     */
    message?: string;
    /**
     *
     * @type {string}
     * @memberof CreateArticleCtaLeadForm
     */
    recaptcha: string;
    /**
     *
     * @type {string}
     * @memberof CreateArticleCtaLeadForm
     */
    articleUrl?: string;
}

export function CreateArticleCtaLeadFormFromJSON(json: any): CreateArticleCtaLeadForm {
    return CreateArticleCtaLeadFormFromJSONTyped(json, false);
}

export function CreateArticleCtaLeadFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateArticleCtaLeadForm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'ctaId': json['ctaId'],
        'name': json['name'],
        'phone': json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'recaptcha': json['recaptcha'],
        'articleUrl': !exists(json, 'articleUrl') ? undefined : json['articleUrl'],
    };
}

export function CreateArticleCtaLeadFormToJSON(value?: CreateArticleCtaLeadForm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'ctaId': value.ctaId,
        'name': value.name,
        'phone': value.phone,
        'email': value.email,
        'message': value.message,
        'recaptcha': value.recaptcha,
        'articleUrl': value.articleUrl,
    };
}


